(() => {
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const selector = 'dotlottie-wc[data-add150-src]';
  function loadPlayer() {
    if (customElements.get('dotlottie-wc')) return Promise.resolve();
    if (!window.dwDotLottiePlayerPromise) {
      window.dwDotLottiePlayerPromise = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.type = 'module';
        script.src = 'https://unpkg.com/@lottiefiles/dotlottie-wc@0.9.24/dist/dotlottie-wc.js';
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });
    }
    return window.dwDotLottiePlayerPromise;
  }
  const observer = new IntersectionObserver(entries => entries.forEach(entry => {
    if (!entry.isIntersecting) return;
    const player = entry.target;
    observer.unobserve(player);
    if (motion.matches) return;
    loadPlayer().then(() => customElements.whenDefined('dotlottie-wc')).then(() => {
      if (!player.isConnected || motion.matches) return;
      player.addEventListener('load', () => {
        player.parentElement.classList.add('is-ready');
        player.dotLottie?.play();
      }, { once: true });
      player.setAttribute('src', player.dataset.add150Src);
      player.setAttribute('autoplay', '');
      // Play once: draws attention without continuous motion beside cart controls.
    }).catch(() => { /* Keep the inline gift visible when the player cannot load. */ });
  }));
  function init() {
    document.querySelectorAll(selector).forEach(player => {
      if (player.dataset.observed) return;
      player.dataset.observed = 'true';
      observer.observe(player);
    });
  }
  init();
  new MutationObserver(records => {
    if (records.some(record => record.addedNodes.length)) init();
    document.querySelectorAll(selector).forEach(player => {
      if (!player.checkVisibility?.()) player.dotLottie?.pause();
    });
  }).observe(document.body, { childList: true, subtree: true });
  motion.addEventListener('change', () => {
    if (motion.matches) document.querySelectorAll(selector).forEach(player => player.dotLottie?.pause());
  });
})();

// Celebrate only a newly reached two-paid-item threshold, never an initial eligible cart.
(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const selector = '#cart .dw-add150-card';
  let previous = null;
  function burst(card) {
    if (reduced.matches || !card.isConnected) return;
    const canvas = document.createElement('canvas');
    canvas.setAttribute('aria-hidden', 'true');
    canvas.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;pointer-events:none;z-index:3;border-radius:inherit;';
    const width = card.clientWidth, height = card.clientHeight;
    const dpr = Math.min(devicePixelRatio || 1, 2);
    canvas.width = width * dpr;
    canvas.height = height * dpr;
    card.appendChild(canvas);
    const ctx = canvas.getContext('2d');
    if (!ctx) { canvas.remove(); return; }
    ctx.scale(dpr, dpr);
    const colors = ['#ffdc69', '#d99a24', '#f5bd3a', '#fff0a3'];
    const sparks = Array.from({length:72}, (_, i) => {
      const angle = i / 72 * Math.PI * 2 + Math.random() * .13;
      const speed = 45 + Math.random() * 140;
      return {vx:Math.cos(angle)*speed, vy:Math.sin(angle)*speed*.65, color:colors[i%4], size:.7+Math.random()*1.3};
    });
    let start;
    function draw(now) {
      if (start === undefined) start = now;
      const t = (now - start) / 1000;
      if (t > 1.6 || !card.isConnected || reduced.matches) { canvas.remove(); return; }
      ctx.clearRect(0, 0, width, height);
      const travel = (1 - Math.exp(-t * 2.4)) / 2.4;
      ctx.globalAlpha = Math.max(0, 1 - t / 1.6);
      for (const spark of sparks) {
        const x = width * .5 + spark.vx * travel * 2;
        const y = height * .46 + spark.vy * travel * 2 + t*t*13;
        ctx.strokeStyle = spark.color;
        ctx.fillStyle = spark.color;
        ctx.lineWidth = spark.size;
        ctx.beginPath();
        ctx.moveTo(x - spark.vx * .045 * (1-t/1.6), y - spark.vy * .045 * (1-t/1.6));
        ctx.lineTo(x,y);
        ctx.stroke();
        ctx.beginPath();ctx.arc(x,y,spark.size,0,Math.PI*2);ctx.fill();
      }
      requestAnimationFrame(draw);
    }
    requestAnimationFrame(draw);
  }
  function check() {
    const card = document.querySelector(selector);
    // Drawer markup can temporarily disappear during an AJAX replacement.
    if (!card) return;
    const quantity = Number(card.querySelector('[role="progressbar"]')?.getAttribute('aria-valuenow'));
    if (!Number.isFinite(quantity)) return;
    const celebrate = previous !== null && previous < 2 && quantity >= 2;
    previous = quantity;
    if (celebrate) burst(card);
  }
  check();
  new MutationObserver(check).observe(document.body, {subtree:true,childList:true,attributes:true,attributeFilter:['aria-valuenow']});
})();
